<template>
<div class="full-wrapper">
  <el-scrollbar :ref="scrollbarRef">
    <div class="full">
      <el-tabs class="tab-button" v-model="subActiveTab">
        <el-tab-pane :label="tabs.application.label" :name="tabs.application.name">
          <w-application-table objtype="INSTANCE" :active="tabs.application.active && active" :params="params" @loadChartData="onChangeChartData" />
        </el-tab-pane>
        <el-tab-pane :label="tabs.sql.label" :name="tabs.sql.name">
          <w-sql-table objtype="INSTANCE" :active="tabs.sql.active && active" :params="params" @loadChartData="onChangeChartData" />
        </el-tab-pane>
        <el-tab-pane :label="tabs.api.label" :name="tabs.api.name">
          <w-api-call-table objtype="INSTANCE" :active="tabs.api.active && active" :params="params" @loadChartData="onChangeChartData" />
        </el-tab-pane>
        <el-tab-pane :label="tabs.exception.label" :name="tabs.exception.name">
          <w-service-error-table objtype="INSTANCE" :active="tabs.exception.active && active" :params="params" @loadChartData="onChangeChartData" />
        </el-tab-pane>
        <el-tab-pane :label="tabs.alert.label" :name="tabs.alert.name">
          <w-alert-table objtype="INSTANCE" :active="tabs.alert.active && active" :params="params" @loadChartData="onChangeChartData" />
        </el-tab-pane>
        <!-- <el-tab-pane :label="tabs.endUser.label" :name="tabs.endUser.name">
          <w-end-user-table objtype="INSTANCE" :active="tabs.endUser.active && active" :params="params" @loadChartData="onChangeChartData" />
        </el-tab-pane> -->
      </el-tabs>
      <w-common-line-chart :visible="active" :chart-data="chartData" />
    </div>
  </el-scrollbar>
  <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty, find } from 'lodash';
import ScrollbarMixin from '@/mixins/scrollbar';
import TabMixin from '@/mixins/apm/tab';
import WApplicationTable from '@/views/apm/components/table/ApplicationTable';
import WSqlTable from '@/views/apm/components/table/SqlTable';
import WApiCallTable from '@/views/apm/components/table/ApiCallTable';
import WServiceErrorTable from '@/views/apm/components/table/ServiceErrorTable';
import WAlertTable from '@/views/apm/components/table/AlertTable';
import WEndUserTable from '@/views/apm/components/table/EndUserTable';
import WCommonLineChart from '@/views/apm/components/chart/CommonLineChart';

export default {
  name: 'WTierSummaryView',
  components: {
    WApplicationTable,
    WSqlTable,
    WApiCallTable,
    WServiceErrorTable,
    WAlertTable,
    WEndUserTable,
    WCommonLineChart,
  },
  mixins: [ScrollbarMixin, TabMixin],
  data() {
    return {
      subActiveTab: null,
      tabs: {
        application: {
          name: 'application',
          label: '어플리케이션',
          active: false,
          default: true,
        },
        sql: {
          name: 'sql',
          label: 'SQL',
          active: false,
        },
        api: {
          name: 'api',
          label: 'API 호출',
          active: false,
        },
        exception: {
          name: 'exception',
          label: '트랜잭션 예외',
          active: false,
        },
        alert: {
          name: 'alert',
          label: '경보',
          active: false,
        },
        endUser: {
          name: 'endUser',
          label: '엔드유저',
          active: false,
        },
      },
      chartData: {},
    };
  },
  computed: {
    params() {
      const selectedNode = this.selectedNode;
      const analysisDateParams = this.analysisDateParams;
      return { selectedObjectTypeText: 'tier', selectedObjectId: selectedNode.tierId, startDatetime: analysisDateParams.startDatetime, endDatetime: analysisDateParams.endDatetime };
    },
    apmSubActiveTab() {
      const tabs = this.tabs;
      const currentTabName = this.$store.state.apm.subActiveTab;
      const currentTab = tabs[currentTabName];
      return isEmpty(currentTab) ? find(tabs, 'default').name : currentTab.name;
    },
    ...mapGetters(['selectedNode', 'analysisDateParams']),
  },
  watch: {
    apmSubActiveTab: {
      immediate: true,
      handler(tabName) {
        this.subActiveTab = tabName;
      },
    },
  },
  mounted() {
    this.setScrollData();
  },
  methods: {
    onChangeChartData(chartData) {
      this.chartData = chartData;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/apm/instance/tier/summary/index.vue